import { render, staticRenderFns } from "./indexgraduate.vue?vue&type=template&id=d0d2dede&scoped=true"
import script from "./indexgraduate.vue?vue&type=script&lang=js"
export * from "./indexgraduate.vue?vue&type=script&lang=js"
import style0 from "./indexgraduate.vue?vue&type=style&index=0&id=d0d2dede&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d2dede",
  null
  
)

export default component.exports